(() => {
  const dialog = document.getElementById('quote-request-dialog');
  if (!dialog) return;
  const status = dialog.querySelector('[data-quote-form-status]');
  const holder = dialog.querySelector('[data-quote-form-frame]');
  const recovery = dialog.querySelector('[data-quote-form-recovery]');
  const updateSubmitLabel = () => {
    const label = document.getElementById('raq_form_submit_text');
    if (label && label.textContent !== dialog.dataset.submit) label.textContent = dialog.dataset.submit;
  };
  new MutationObserver(updateSubmitLabel).observe(document.body, { childList: true, subtree: true });
  updateSubmitLabel();
  let host;
  let originalParent;
  let originalModal;
  let opener;
  let timer;
  let observer;
  let prepared = false;
  let finished = false;
  const cleanup = () => {
    clearTimeout(timer);
    observer?.disconnect();
    if (originalParent && originalModal && originalParent.isConnected) {
      originalModal.style.display = 'none';
      originalParent.append(originalModal);
    }
    originalParent = null;
    originalModal = null;
    holder.replaceChildren();
    host?.remove();
    host = null;
    prepared = false;
    finished = false;
  };
  const load = async () => {
    cleanup();
    status.hidden = false;
    status.textContent = dialog.dataset.loading;
    recovery.hidden = true;
    holder.hidden = false;
    const drawer = document.querySelector('quote-drawer');
    try {
      const api = await drawer.ready();
      if (!dialog.open) return;
      if (typeof api.process_quote_list !== 'function') throw new Error('Quote form API unavailable');
      if (!document.getElementById('tpl_sc_raq_list')) {
        const response = await fetch(drawer.querySelector('[data-quote-request]').href, { signal: AbortSignal.timeout(12000) });
        if (!response.ok) throw new Error('Quote form page unavailable');
        const page = new DOMParser().parseFromString(await response.text(), 'text/html');
        page.querySelectorAll('script[id^="tpl_sc_raq_"]').forEach((template) => {
          if (!document.getElementById(template.id)) document.body.append(document.importNode(template, true));
        });
        if (!document.getElementById('tpl_sc_raq_list')) throw new Error('Quote form template unavailable');
      }
      if (!dialog.open) return;
      const existingModal = document.getElementById('raq_quote_form_modal');
      if (existingModal) {
        originalModal = existingModal;
        originalParent = existingModal.parentElement;
      } else {
        host = document.createElement('div');
        host.id = 'sc_raq_list';
        host.hidden = true;
        document.body.append(host);
      }
      const check = () => {
        const modal = document.getElementById('raq_quote_form_modal');
        if (!prepared && modal?.querySelector('#raq_form_submit')) {
          prepared = true;
          modal.querySelectorAll('input:not([type="hidden"]), textarea').forEach((field) => {
            if (field.placeholder) field.setAttribute('aria-label', field.placeholder);
            if (field.dataset.required === '1') field.required = true;
            if (field.id === 'raq_email') field.type = 'email';
          });
          const formError = host?.querySelector('#form_error');
          if (formError && !modal.contains(formError)) holder.append(formError);
          holder.append(modal);
          modal.addEventListener('click', (event) => {
            if (!event.target.closest('#raq_form_submit')) return;
            const invalid = [...modal.querySelectorAll('input:not([type="hidden"]), textarea, select')].find((field) => !field.checkValidity());
            if (invalid) {
              event.preventDefault();
              event.stopImmediatePropagation();
              invalid.reportValidity();
            }
          }, true);
          api.open_submit_popup();
          status.hidden = true;
          recovery.hidden = true;
          clearTimeout(timer);
        }
        if (prepared && !finished && api.get_added_item_list().length === 0) {
          finished = true;
          holder.hidden = true;
          status.hidden = false;
          status.textContent = dialog.dataset.success;
          drawer.syncApp();
        }
      };
      observer = new MutationObserver(check);
      observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });
      timer = setTimeout(() => {
        status.textContent = dialog.dataset.error;
        recovery.hidden = false;
      }, 20000);
      if (!existingModal) api.process_quote_list();
      check();
    } catch (error) {
      console.warn('Quote form:', error);
      status.textContent = dialog.dataset.error;
      recovery.hidden = false;
    }
  };
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-quote-request]');
    if (!trigger || event.button > 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    opener = trigger;
    removeTrapFocus();
    dialog.showModal();
    load();
  });
  dialog.querySelector('[data-quote-form-close]').addEventListener('click', () => dialog.close());
  dialog.querySelector('[data-quote-form-retry]').addEventListener('click', load);
  dialog.addEventListener('click', (event) => {
    if (event.target !== dialog) return;
    const bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => {
    cleanup();
    const drawer = document.querySelector('quote-drawer');
    drawer?.syncApp();
    if (drawer?.hasAttribute('open')) {
      drawer.refresh();
      trapFocus(drawer, opener);
    } else {
      opener?.focus({ preventScroll: true });
    }
  });
})();
